const getQueryErrorTryAgainLater = (errorPlace: string): string => {
  return `Ошибка ${errorPlace}. В случае повторения ошибки попробуйте повторно пройти процедуру авторизации`;
};

export default getQueryErrorTryAgainLater;
